"use client"
import React, { useState, useEffect, useRef } from "react";
import CommunityDirectoryView from "@/components/communities/CommunityDirectoryView";
import { useRouter, useSearchParams } from "next/navigation";
import { useTenant } from "@/lib/providers/TenantProvider";

// profileType: "BUSINESS" (default) or "ORGANIZATION" for the organizations directory
const EmbeddedDirectoryWidget = ({ profileType = "BUSINESS" }) => {
  const { profile, community } = useTenant();
  
  const [loaded, setLoaded] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [scrollable, setScrollable] = useState(false);
  const [includeCoverPhoto, setIncludeCoverPhoto] = useState(false);
  const [publicTags, setPublicTags] = useState(null);
  const [showSearchFilter, setShowSearchFilter] = useState(true);
  const [showOpenNow, setShowOpenNow] = useState(true);
  const [systemLayerTypes, setSystemLayerTypes] = useState(null);

  const searchParams = useSearchParams();
  const token = searchParams.get("key");
  const showMapParam = searchParams.get("showMap") === "true";
  const scrollableParam = searchParams.get("scrollable") === "true";
  const includeCoverPhotoParam = searchParams.get("includeCoverPhoto") === "true";
  const taggedParam = searchParams.get("tagged");
  const searchFilterParam = searchParams.get("searchFilter");
  // openNow=false hides the "Open Now" filter toggle
  const openNowParam = searchParams.get("openNow");
  // sl: comma-separated system layers to draw on the map, e.g. sl=BOUNDARY
  const systemLayersParam = searchParams.get("sl");

  useEffect(() => {
    if (token && !loaded) {
      if (showMapParam) setShowMap(true);
      if (scrollableParam) setScrollable(true);
      if (includeCoverPhotoParam) setIncludeCoverPhoto(true);
      if (taggedParam) {
        const parsed = taggedParam.split(",").map(t => t.trim()).filter(Boolean);
        if (parsed.length > 0) setPublicTags(parsed);
      }
      if (searchFilterParam === "false") setShowSearchFilter(false);
      if (openNowParam === "false") setShowOpenNow(false);
      if (systemLayersParam) {
        const parsed = systemLayersParam.split(",").map(t => t.trim().toUpperCase()).filter(Boolean);
        if (parsed.length > 0) setSystemLayerTypes(parsed);
      }
      setLoaded(true);
    }
  }, [token, showMapParam, scrollableParam, includeCoverPhotoParam, taggedParam, searchFilterParam, openNowParam, systemLayersParam, profile, community, loaded]);

  if (loaded) {
    return (
      <div className="embedded-directory-widget">
        <CommunityDirectoryView
          name={profile.resourceName}
          community={community}
          types={[profileType]}
          includeCoverPhoto={includeCoverPhoto}
          publicTags={publicTags}
          showMap={showMap}
          scrollable={scrollable}
          showSearchFilter={showSearchFilter}
          showOpenNow={showOpenNow}
          systemLayerTypes={systemLayerTypes}
          external={true}
          token={token}
        />
      </div>
    );
  } else {
    return <></>;
  }
};

export default EmbeddedDirectoryWidget;
